/* BloomFolkLiving: load the hover (second) image of product cards ahead of time (own code) */
(function () {
  function prime(root) {
    root.querySelectorAll('.card-gallery').forEach(function (g) {
      var imgs = g.querySelectorAll('img');
      if (imgs.length > 1 && imgs[1].loading === 'lazy') {
        imgs[1].loading = 'eager';
        imgs[1].setAttribute('fetchpriority', 'low');
      }
    });
  }
  function run() {
    prime(document);
    new MutationObserver(function (m) {
      if (m.some(function (x) { return x.addedNodes.length; })) prime(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
